module.exports = __webpack_public_path__ + "img/icon-producao-medica.6b0ca68e.svg";